import { isNil } from 'lodash-es';

import { formatNumber } from 'utils/number';
import type { CalculationType } from 'components/nri-table/types';

/**
 * Title for the popup, e.g. "Total Slot NRI" or "Total Slot WI".
 *
 * @param {CalculationType} calculationType - Which interest the popup is showing.
 * @return {string} The popup title.
 */
export const getSlotTitle = (calculationType: CalculationType): string => {
  return calculationType === 'NRI' ? 'Total Slot NRI' : 'Total Slot WI';
};

/**
 * Header for the rightmost column in the popup table.
 *
 * @param {CalculationType} calculationType - Which interest the popup is showing.
 * @return {string} The column header.
 */
export const getInterestHeader = (calculationType: CalculationType): string => {
  return calculationType === 'NRI' ? 'UAT NRI' : 'UAT WI';
};

/**
 * Renders an allocation factor as a percentage with two decimal places, or `--`
 * when the value is nullish.
 *
 * @param {number} [factor] - Allocation factor in [0, 1].
 * @return {string} The formatted percentage.
 */
export const formatFactor = (factor?: number): string => {
  if (isNil(factor)) return '--';
  return formatNumber(factor * 100, 2, 2, 'decimal', false, '--', '%');
};
